// extracted by mini-css-extract-plugin
module.exports = {"selected":"MenuCard_selected__1-Pl2","deselected":"MenuCard_deselected__3UcYk"};